import * as React from "react";
import moment from "moment";
import styled from 'styled-components'

// icons
import "font-awesome/css/font-awesome.min.css";

// styling
import "bootstrap/dist/css/bootstrap.min.css";

// toast
import "react-toastify/dist/ReactToastify.css";

// flags
import "flag-icon-css/css/flag-icon.css";

import "rc-steps/assets/index.css";
import "rc-steps/assets/iconfont.css";

import Steps, { Step } from "rc-steps";
import { Scrollbars } from "react-custom-scrollbars";

import { IoMdClose, IoIosArrowForward } from "react-icons/io";
import Modal from "react-awesome-modal";
// import Vimeo from '@u-wave/react-vimeo';
import Vimeo from '../../components/VimeoPlayer/VimeoPlayer.Component';

// services
import {
  createItemGen,
  currentBaseUrl,
  currentDesignation,
  currentUser,
  getGeneralDirect,
  getGeneralSmartTableData,
  isUserLoggedIn,
  currentLesson,
  setCurrentLessonAttempt
} from "../../common/services";

// components

import NavBar from "../../components/CustomNav/CustomNav.Component";

// loader
import SimpleLoader from "../../common/simpleLoader.Component";

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer } from "react-toastify";

// tabs
import { Breadcrumb, BreadcrumbItem, Button, Col, Row } from "reactstrap";

// contants
import { APIBASE, MEDIABASE, PROXIED_MEDIABASE } from "../../common/constants";

// video player
import { Player, BigPlayButton } from "video-react";
import "node_modules/video-react/dist/video-react.css";

// page specific styling
import { CSSTransition } from "react-transition-group";
import "./lessonPreview.css";

import Loader from "react-loader";

// interactions
import RecallInteraction from "../../components/RecallInteraction/RecallInteraction.Component";
import DragDropInteraction from "../../components/DnDInteraction/DragDropInteraction.Component";
import MultipleChoiceInteraction from "../../components/MultipleChoiceInteraction/MultipleChoiceInteraction.Component";
import MultipleChoiceMultiInteraction from "../../components/MultipleChoiceMultiInteraction/MultipleChoiceMultiInteraction.Component";

// utils
import { processDrag, processRedWords } from "../../common/utils";

import CustomDocumentViewer from "../../common/documentViewer";

import CustomViewer from "../../common/screenViewer";

import CustomImageEditor from "../../common/documentEditor";
import ScreenViewer from "../../common/screenViewerHtml";
import CustomCalendar from "../../common/Lessons/customCalendar.Component";
import VideoPlayer from "src/components/VideoPlayer/VideoPlayer";

interface IProps {
  history?: any
}

const PreviewRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    div {
        margin-right: 16px;
    }
`
const AssetWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.alignment ? props.alignment : 'flex-start'};
    justify-content: center;
    max-width: ${props => props.assetWidth}%;
    width: ${props => props.assetWidth}%;
    min-width: ${props => props.assetWidth}%;
    padding: 8px;
`
const PreviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    background-color: ${props => props.bgColor};
    color: #fff;
    width: 100%;
    min-height: 600px;
    min-width: 600px;
    height: 100%;
    padding: 32px 32px;
`
class LessonPreviewPage extends React.Component<IProps> {
  public state = {
    background: "#0000",
    baseurl: currentBaseUrl(),
    currentinteractiondata: {} as any,
    currentscreenidx: 0,
    currentscreen: {},
    color: "#0000",
    destination: "",
    draft: "",
    editorState: "",
    font: "Anton",
    htmltext: "",
    lesson: {} as any,
    loaded: false,
    mounted: false,
    navigate: false,
    screens: [] as any[],
    tologin: false,
    username: "",
    reschedule: false,

    // pdf render
    numPages: null,
    chooseTutorEnabled: false, // future use - enabling/disabling choosing a tutor
    openModal: false,

    // rescheduling lesson in modal state
    openScheduleModal: false,
    allocations: [],
    events: [] as any
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.handleGenSmartDataLoaded = this.handleGenSmartDataLoaded.bind(this);
    this.loadScreenData = this.loadScreenData.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    // this.handleReschedule = this.handleReschedule.bind(this);
    this.handleChooseTutor = this.handleChooseTutor.bind(this);
    this.handleInteractionInfoloaded = this.handleInteractionInfoloaded.bind(
      this
    );
    this.handleInteractionloaded = this.handleInteractionloaded.bind(this);
    this.interactionComplete = this.interactionComplete.bind(this);
    this.goBack = this.goBack.bind(this);
    this.onStepClick = this.onStepClick.bind(this);
    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.closeScheduleModal = this.closeScheduleModal.bind(this);
    this.openScheduleModal = this.openScheduleModal.bind(this);
    this.getEventIndex = this.getEventIndex.bind(this);
    this.handleAllocationsLoaded = this.handleAllocationsLoaded.bind(this);
    this.handleRequestCompleted = this.handleRequestCompleted.bind(this);
    this.onDragStop = this.onDragStop.bind(this);
    this.handleLessonLoaded = this.handleLessonLoaded.bind(this);
  }

  public onLogout(arg) {
    console.log("Logout in Parent", arg);
    this.setState({ tologin: true });
  }

  public toggleModal() {
    const modalstate = this.state.openModal;
    this.setState({ openModal: !modalstate });
  }
  public openScheduleModal() {
    // get lesson allocations
    getGeneralSmartTableData("overview/lesson_allocations", text =>
      this.handleAllocationsLoaded(text)
    );
  }

  public closeScheduleModal() {
    this.setState({ openScheduleModal: false });
  }

  public currentid() {
    const key1 = "match";
    return this.props[key1].params.id;
  }

  public getEndTime(dateString, duration) {
    const date = new Date(dateString);
    date.setHours(date.getHours() + duration);
    return date;
  }
  public getEventIndex(array, attr, val) {
    for (let i = 0; i < array.length; i++) {
      if (array[i][attr] === val) {
        return i;
      }
    }
    return -1;
  }
  public onDragStop(args) {
    const currentEvent = args.data;
    const events = this.state.events;
    const prevEvtIdx = this.getEventIndex(
      events,
      "LessonId",
      currentEvent.LessonId
    );
    // const lessonId = currentEvent.LessonId;
    const lessonidx = currentEvent.Id;
    const item = {
      Time: currentEvent.StartTime.getTime() / 1000
    };
    if (
      events[prevEvtIdx].StartTime < new Date() ||
      currentEvent.StartTime < new Date()
    ) {
      toast.error("You Cannot Change The Past!");
      this.setState({ events });
    } else {
      createItemGen(
        "lesson_allocations/" + lessonidx + "/reschedule/",
        item,
        text => this.handleRequestCompleted(text, events)
      );
    }
  }
  public handleAllocationsLoaded(res) {
    if (res.code === 200) {
      console.log(
        "Allocations loaded" +
        JSON.stringify(res.response.lessonallocations, null, 4)
      );
      const tempevents = [] as any;
      for (const curritem of res.response.lessonallocations) {
        // const curritem = res.response.lessonallocations;
        const evt = {
          Id: curritem.id,
          Subject: curritem.Title,
          StartTime: new Date(curritem.DueDate),
          EndTime: this.getEndTime(curritem.DueDate, curritem.Duration),
          LessonId: curritem.LessonId
        };
        // console.log("All ALLocs: " + JSON.stringify(evt, null, 4));
        tempevents.push(evt);
      }
      const modalstate = this.state.openScheduleModal;
      this.setState({
        allocations: res.response.lessonallocations,
        events: tempevents,
        openScheduleModal: true
      });
    }
  }
  public handleRequestCompleted(res, prevevents) {
    if (res.code === 200) {
      getGeneralSmartTableData("overview/lesson_allocations", text =>
        this.handleAllocationsLoaded(text)
      );
      toast.success("Reschedule Successful");
      this.setState({ openScheduleModal: true });
    } else {
      toast.error("Sorry, request failed");
      this.setState({
        events: prevevents
      });
    }
  }

  public handleInteractionInfoloaded(res) {
    console.log(res);
    const interactioninfo = res.response as any;

    if (res.code !== 200) {
      toast.error("Error finding interactions");
      return;
    }

    const modifiedurl =
      APIBASE + interactioninfo.interaction_url.replace("/api/v1/", "");
    console.log(modifiedurl);
    getGeneralDirect(modifiedurl, text => this.handleInteractionloaded(text));
  }

  public handleInteractionloaded(res) {
    console.log(res);
    this.setState({
      processingmodal: false,
      currentinteractiondata: res.response
    });
  }

  public loadScreenData() {
    const keyid = "id";
    const keyscreentype = "ScreenType";
    const keyvideourl = "VideoUrl";
    const keydisplaydata = "DisplayData";
    const keyhtml = "html";
    const keydraft = "draft";
    const keybg = "background";
    const keycolor = "color";
    const keyfont = "font";

    const currentscreen = this.state.screens[this.state.currentscreenidx];

    this.setState({ currentscreen });

    if (currentscreen[keyscreentype] === 0) {
      // this.setState({ currentscreen });
      console.log('yuu');

    } else if (currentscreen[keyscreentype] === 1) {
      this.setState({ processingmodal: true });
      getGeneralSmartTableData(
        "admin/lessons/" +
        this.currentid() +
        "/lesson_screen/?screen_no=" +
        currentscreen[keyid],
        text => this.handleInteractionInfoloaded(text)
      );
    }
  }

  public openWidget(param, e) {
    console.log("widget: " + param);
    this.setState({ destination: currentBaseUrl() + param });
    this.setState({ navigate: true });
  }

  public onChange(arg) {
    console.log("On change", arg);
  }

  public async componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ tologin: true });
    } else {
      const currentlesson = currentLesson();

      console.log(currentlesson);

      // load data
      getGeneralSmartTableData(
        "admin/lesson_screens/by_lesson/?id=" + this.currentid(),
        text => this.handleGenSmartDataLoaded("screens", "screens", text)
      );

      getGeneralSmartTableData(
        "admin/lessons/" + this.currentid() + "/",
        text => this.handleLessonLoaded(text)
      );

    }

    this.setState({ username: currentUser() });

    this.setState({ mounted: true });
  }

  public handleLessonLoaded(res) {
    console.log(res.response);
    this.setState({ lesson: res.response });
  }
  public shouldComponentUpdate(nextState) {
    if (this.state.openScheduleModal === nextState.openScheduleModal) {
      return false;
    } else {
      return true;
    }
  }

  public handleAttemptLoaded(res) {
    if (res.code === 200) {
      setCurrentLessonAttempt(res.response);
      console.log(res);
    }
  }

  public handleGenSmartDataLoaded(key, objkey, res) {
    if (res.code === 200) {
      console.log("SCREENS RES: " + res.response);
      this.setState({ loaded: true });
      this.setState({ [key]: res.response[objkey] });
      this.loadScreenData();
      // this.setState({htmltext: currentscreen[keydisplaydata].html});
    }
    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public nextPage() {
    if (this.state.currentscreenidx < this.state.screens.length - 1) {
      const newval = this.state.currentscreenidx + 1;
      this.setState({ currentscreenidx: newval, currentscreen: {} });
      setTimeout(this.loadScreenData, 10);
    } else if (this.state.currentscreenidx === this.state.screens.length - 1) {
      // finished all preview screens
      this.props.history.goBack();
      // this.setState({
      //   destination: currentBaseUrl() + "lessons/" + this.currentid(),
      //   navigate: true
      // });
    }
  }

  public previousPage() {
    if (this.state.currentscreenidx > 0) {
      const newval = this.state.currentscreenidx - 1;
      this.setState({ currentscreenidx: newval, currentscreen: {} });
      setTimeout(this.loadScreenData, 10);
    }
  }

  public interactionComplete() {
    console.log("complete");
    this.state.screens[this.state.currentscreenidx].exclude = true;
    this.nextPage();
  }

  public onStepClick(currentscreenidx) {
    this.setState({ currentscreenidx });
    setTimeout(this.loadScreenData, 100);
  }

  public onDocumentLoadSuccess(val) {
    this.setState({ numPages: val });
  }

  public showInteraction() {
    if (this.state.currentinteractiondata === {}) {
      return <p>No Interaction Data</p>;
    } else {
      if (this.state.currentinteractiondata.interaction_type === "choice") {
        if (this.state.currentinteractiondata.choice_type === "single_choice") {
          return (
            <MultipleChoiceInteraction
              oncomplete={this.interactionComplete}
              demomode={true}
              show={true}
              lessonid={this.currentid()}
              interactionid={this.state.currentinteractiondata.id}
              completiontext={this.state.currentinteractiondata.completion_text}
              submittext={"Submit"}
              introtext={this.state.currentinteractiondata.intro_text}
              question={this.state.currentinteractiondata.question_text}
              answers={this.state.currentinteractiondata.choice_answers}
              penalty={this.state.currentinteractiondata.penalty}
              timelimit={this.state.currentinteractiondata.time_limit}
            />
          );
        } else {
          return (
            <MultipleChoiceMultiInteraction
              oncomplete={this.interactionComplete}
              demomode={true}
              show={false}
              lessonid={this.currentid()}
              interactionid={this.state.currentinteractiondata.id}
              completiontext={this.state.currentinteractiondata.completion_text}
              submittext={"Submit"}
              introtext={this.state.currentinteractiondata.intro_text}
              question={this.state.currentinteractiondata.question_text}
              answers={this.state.currentinteractiondata.choice_answers}
              penalty={this.state.currentinteractiondata.penalty}
              timelimit={this.state.currentinteractiondata.time_limit}
            />
          );
        }
      } else if (
        this.state.currentinteractiondata.interaction_type === "draganddrop"
      ) {
        return (
          <DragDropInteraction
            oncomplete={this.interactionComplete}
            demomode={true}
            show={true}
            lessonid={this.currentid()}
            interactionid={this.state.currentinteractiondata.id}
            completiontext={this.state.currentinteractiondata.completion_text}
            submittext={"Submit"}
            introtext={this.state.currentinteractiondata.intro_text}
            dragquestions={
              this.state.currentinteractiondata.options}
            penalty={this.state.currentinteractiondata.penalty}
            timelimit={this.state.currentinteractiondata.time_limit}
          />
        );
      } else if (
        this.state.currentinteractiondata.interaction_type === "recall"
      ) {
        return (
          <RecallInteraction
            oncomplete={this.interactionComplete}
            demomode={true}
            show={true}
            lessonid={this.currentid()}
            interactionid={this.state.currentinteractiondata.id}
            completiontext={this.state.currentinteractiondata.completion_text}
            submittext={"Submit"}
            introtext={this.state.currentinteractiondata.intro_text}
            question={this.state.currentinteractiondata.paragraph_copy}
            redwords={processRedWords(
              this.state.currentinteractiondata.recall_words
            )}
            penalty={this.state.currentinteractiondata.penalty}
            timelimit={this.state.currentinteractiondata.time_limit}
          />
        );
      }

      return <Loader />;
    }
  }

  public dummy(val) {
    console.log("dummy");
  }

  public generatePreviewAsset = (asset, idx, rowId, columns) => {
    if (asset === null) {
      return <p style={{ width: '100%' }} />
    } else {
      if (asset.type === 'image') {
        return <AssetWrapper assetWidth={Math.round(100 / columns)} alignment={this.getAlignment(asset.align)} key={`${rowId}-${idx}`} >
          <img src={asset.content} style={{ width: `${asset.size}px` }} alt="img" />
        </AssetWrapper>
      }
      if (asset.type === 'icon') {
        return <AssetWrapper assetWidth={Math.round(100 / columns)} alignment={this.getAlignment(asset.align)} key={`${rowId}-${idx}`} >
          <img src={asset.content} style={{ width: `${asset.size}px` }} alt="icon" />
        </AssetWrapper>
      }
      if (asset.type === 'text') {
        return <div style={{ maxWidth: `${Math.round(100 / columns)}%`, width: '100%', padding: '8px' }} key={`${rowId}-${idx}`} dangerouslySetInnerHTML={{ __html: asset.content }} />
      }

      if (asset.type === 'video') {
        return <AssetWrapper assetWidth={Math.round(100 / columns)} alignment={this.getAlignment(asset.align)} key={`${rowId}-${idx}`} >
          <video src={asset.content} style={{ width: `${asset.size}px` }} controls={true} />
        </AssetWrapper>
      }
    }
    return;
  }
  public getAlignment = (align) => {
    if (align === 'left') { return 'flex-start' }
    if (align === 'center') { return 'center' }
    if (align === 'right') { return 'flex-end' }
    return;
  }


  public screendisplay2(currentscreen) {
    if (this.state.screens.length > 0) {
      const keyscreentype = "ScreenType";
      const keyvideourl = "VideoUrl";
      const keydisplaydata = "DisplayData";

      if (currentscreen.length < 1) {
        return (<p style={{ color: 'white' }}>Helo there tgis dhfdghfhd dhdhdh</p>);
      }
      // if current screen type is content
      if (currentscreen[keyscreentype] === 0) {
        // first page     
        const { LessonScreenId } = currentscreen;
        const { rows, rowOrder } = currentscreen.DisplayData;
        if (this.state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">

                <PreviewContainer bgColor={currentscreen[keydisplaydata].background}>
                  <React.Fragment>
                    {rowOrder.map((rowId, idx) => {
                      const row = rows[rowId];
                      const assets = row.assets;

                      return <PreviewRow
                        key={`${LessonScreenId}-${row.id}`}
                      >
                        {assets.map((asset, idx) => {
                          { return this.generatePreviewAsset(asset, idx, rowId, assets.length) }
                        })}
                      </PreviewRow>
                    })}
                  </React.Fragment>
                </PreviewContainer>
                {/* <CustomViewer screenid={currentscreen.id}/> */}
                {/* <ScreenViewer
                    screenpdf={currentscreen[keydisplaydata].html}
                    screenbg={currentscreen[keydisplaydata].background}
                  /> */}


              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="blue-button start-lesson"
                  onClick={this.nextPage}
                >
                  Start Lesson
                </button>
              </div>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                {/* <CustomViewer screenid={currentscreen.id} /> */}
                {/* <ScreenViewer
                  screenpdf={currentscreen[keydisplaydata].html}
                  screenbg={currentscreen[keydisplaydata].background}
                /> */}

                <PreviewContainer bgColor={currentscreen[keydisplaydata].background}>
                  <React.Fragment>
                    {rowOrder.map((rowId, idx) => {
                      const row = rows[rowId];
                      const assets = row.assets;

                      return <PreviewRow
                        key={`${LessonScreenId}-${row.id}`}
                      >
                        {assets.map((asset, idx) => {
                          { return this.generatePreviewAsset(asset, idx, rowId, assets.length) }
                        })}
                      </PreviewRow>
                    })}
                  </React.Fragment>
                </PreviewContainer>


              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button blue-button"
                  onClick={this.previousPage}
                >
                  Prev
                </button>
                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of{" "}
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      } else if (currentscreen[keyscreentype] === 1) {

        if (currentscreen.exclude) {

          return (
            <div>

              <p style={{ color: '#ff0033' }}>You have already completed this interaction.</p>

              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button blue-button"
                  onClick={this.previousPage}
                >
                  Prev
                </button>
                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of{" "}
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>

            </div>
          );

        }

        else {

          return (
            <div className="lesson-preview--content">
              {this.showInteraction()}
            </div>
          );
        }

      }
      // image
      else if (currentscreen[keyscreentype] === 3) {
        if (this.state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-image-container">
                  <img
                    style={{ width: "100% !important" }}
                    className="lesson-screen-image"
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}

                  >
                    {/* <BigPlayButton position="center" /> */}
                  </img>
                </div>
              </div>
              <button
                className="lesson-preview--button blue-button"
                onClick={this.nextPage}
              >
                Start Lesson
              </button>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-image-container">
                  <img
                    // style={{ width: "858px" }}
                    // poster={MEDIABASE + "assets/" + "download.jpg"}
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}

                  >
                    {/* <BigPlayButton position="center" /> */}
                  </img>
                </div>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.previousPage}
                >
                  Prev
                </button>

                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      }
      // video
      else if (currentscreen[keyscreentype] === 2) {
        if (this.state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <Player
                    // style={{ height: "500" }}
                    playsInline={true}
                    // poster={MEDIABASE + "assets/" + "download.jpg"}
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}
                    height={640}
                    width={960}
                  >
                    {/* <BigPlayButton position="center" /> */}
                  </Player>
                </div>
              </div>
              <button
                className="lesson-preview--button blue-button"
                onClick={this.nextPage}
              >
                Start Lesson
              </button>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <Player
                    playsInline={true}
                    // poster={MEDIABASE + "assets/" + "download.jpg"}
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}
                    height={640}
                    width={960}
                  >
                    <BigPlayButton position="center" />
                  </Player>
                </div>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.previousPage}
                >
                  Prev
                </button>

                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      } else if (currentscreen[keyscreentype] === 4) {
        if (this.state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <VideoPlayer
                    videoId={currentscreen.VideoUrl}
                    width="480px"
                    height="480px"
                  />
                </div>
              </div>
              <button
                className="lesson-preview--button blue-button"
                onClick={this.nextPage}
              >
                Start Lesson
              </button>
            </div>
          );
        } else {
          console.log(currentscreen.VideoUrl)
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <VideoPlayer
                    videoId={`https://player.vimeo.com/video/${currentscreen.VideoUrl}`}
                    width="480px"
                    height="480px"
                  />
                </div>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.previousPage}
                >
                  Prev
                </button>

                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      }

      else {
        return this.intermediate()
      }
    }


    else {
      return <SimpleLoader loaded={false} />;
    }
  }

  public intermediate() {

    return (
      <div style={{ height: '100vh' }}>
        ""
      </div>
    );
  }

  public screendisplay(state) {
    if (state.screens.length > 0) {
      const keyscreentype = "ScreenType";
      const keyvideourl = "VideoUrl";
      const keydisplaydata = "DisplayData";
      const currentscreen = state.screens[state.currentscreenidx];
      console.log("CurrenTDispData: " + currentscreen[keydisplaydata]);

      if (currentscreen.length < 1) {
        return (<Loader />);
      }
      // if current screen type is content
      if (currentscreen[keyscreentype] === 0) {
        // first page
        if (state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div
                  style={{
                    all: "revert",
                    backgroundColor: `${currentscreen[keydisplaydata].background}`,
                    color: "unset"
                  }}
                >
                  {/* <CustomViewer screenid={currentscreen.id}/> */}
                  <ScreenViewer
                    screenpdf={currentscreen[keydisplaydata].html}
                    screenbg={currentscreen[keydisplaydata].background}
                  />
                </div>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="blue-button start-lesson"
                  onClick={this.nextPage}
                >
                  Start Lesson
                </button>
              </div>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                {/* <CustomViewer screenid={currentscreen.id} /> */}
                <ScreenViewer
                  screenpdf={currentscreen[keydisplaydata].html}
                  screenbg={currentscreen[keydisplaydata].background}
                />
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button blue-button"
                  onClick={this.previousPage}
                >
                  Prev
                </button>
                <p className="current-screen">
                  Page {state.currentscreenidx + 1} of{" "}
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      } else if (currentscreen[keyscreentype] === 1) {
        return (
          <div className="lesson-preview--content">
            {this.showInteraction()}
          </div>
        );
      }
      // video
      else if (currentscreen[keyscreentype] === 2) {
        if (state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <Player
                    // style={{ height: "500" }}
                    playsInline={true}
                    // poster={MEDIABASE + "assets/" + "download.jpg"}
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}
                    height={640}
                    width={960}
                  >
                    {/* <BigPlayButton position="center" /> */}
                  </Player>
                </div>
              </div>
              <button
                className="lesson-preview--button blue-button"
                onClick={this.nextPage}
              >
                Start Lesson
              </button>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <Player
                    playsInline={true}
                    // poster={MEDIABASE + "assets/" + "download.jpg"}
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}
                    height={640}
                    width={960}
                  >
                    <BigPlayButton position="center" />
                  </Player>
                </div>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.previousPage}
                >
                  Prev
                </button>

                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      }
      // image
      else if (currentscreen[keyscreentype] === 3) {
        if (state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-image-container">
                  <img
                    className="lesson-screen-image"
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}
                  />
                </div>
              </div>
              <button
                className="lesson-preview--button blue-button"
                onClick={this.nextPage}
              >
                Start Lesson
              </button>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-image-container">
                  <img
                    className="lesson-screen-image"
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}

                  />
                </div>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.previousPage}
                >
                  Prev
                </button>

                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      }

      else {
        return <p>Unsupported Content</p>;
      }
    } else {
      return <SimpleLoader loaded={false} />;
    }
  }

  public navbuttons() {
    if (this.state.screens.length > 1) {
      return (
        <Col xs="12" md="12" sm="12" lg="12">
          <button style={{ marginRight: 9 }} onClick={this.previousPage}>
            Prev
          </button>

          <button style={{ marginRight: 9 }} onClick={this.nextPage}>
            Next
          </button>

          <p>
            Page {this.state.currentscreenidx + 1} of{" "}
            {this.state.screens.length}
          </p>
        </Col>
      );
    } else {
      return (
        <div>
          <p />
        </div>
      );
    }
  }

  public goBack() {
    this.props.history.goBack();

    // const currentD = currentDesignation() as string;
    // if (currentD === "admins") {
    //   // this.openWidget('singlelesson/' + this.currentid(), this)

    //   this.setState({
    //     destination: currentBaseUrl() + "lessons/" + this.currentid(),
    //     navigate: true
    //   });
    // } else {
    //   this.setState({ destination: currentBaseUrl() + "lessons", navigate: true });
    // }
  }


  public handleChooseTutor() {
    // set destination path to choose tutor component
    this.setState({
      destination: currentBaseUrl() + "singlelesson/choosetutor/",
      navigate: true
    });
  }

  public modal() {
    const vidUrlKey = "VideoUrl";
    return (
      <Modal
        visible={this.state.openModal}
        effect="fadeInUp"
        styles={{ backgroundColor: "transparent" }}
        container={{ background: "#ff0033" }}
        onClickAway={this.toggleModal}
      >
        <div className="lesson-modal-container">
          <div className="lesson-modal-content">
            <div className="lesson-modal-content-header">
              <h1>How do Lessons Work?</h1>
              <IoMdClose
                size="32px"
                onClick={this.toggleModal}
                className="lesson-modal-close"
              />
            </div>
            <div className="lesson-modal-body">
              <h4 className="lesson-modal-description">
                What is this lesson about?
              </h4>
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Amet
                non odio voluptatibus, officiis beatae quam modi quas delectus
                hic optio, nihil ipsum iure iusto iste culpa numquam tempore
                dolores consectetur at exercitationem inventore. Facere dicta at
                qui deserunt, culpa repellat?
              </p>
              <div className="lesson-modal-video">
                <Player
                  playsInline={true}
                  // poster={MEDIABASE + "assets/" + "download.jpg"}
                  src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                  height={480}
                  width={640}
                >
                  <BigPlayButton position="center" />
                </Player>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
  public rescheduleModal() {
    return (
      <Modal
        visible={this.state.openScheduleModal}
        effect="fadeInDown"
        onClickAway={this.closeScheduleModal}
      >
        <div className="lesson-modal-container">
          <div className="lesson-modal-content">

            <IoMdClose
              size="32px"
              onClick={this.closeScheduleModal}
              className="schedule-modal-close"
            />

            <div className="lesson-modal-body">
              <CustomCalendar
                scheduleEvts={this.state.events}
                onDragStop={this.onDragStop}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
  public render() {
    const lesson = currentLesson();
    const keyscreentype = "ScreenType";
    const currentscreen = this.state.screens[this.state.currentscreenidx];
    if (this.state.tologin === true) {
      return <Redirect to="/login" />;
    }

    if (this.state.navigate === true) {
      return <Redirect to={this.state.destination} />;
    }
    return (
      <div className="lesson-preview--container">
        <NavBar logoutParent={this.onLogout} />
        <ToastContainer />
        <SimpleLoader loaded={this.state.loaded} />
        <div style={{ display: "None" }}>
          <p className="apply-font">The font will be applied to this text.</p>
        </div>
        {this.modal()}
        {this.rescheduleModal()}
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="lesson-preview--screen-content">
            <div className="lesson-preview--header">
              <p className="go-back" onClick={this.goBack}>
                &lt; Exit
              </p>

              {currentDesignation() === "students" ? (
                <div className="lesson-preview--lesson-options">
                  <button
                    className="blue-button choose-tutor-button"
                    onClick={this.handleChooseTutor}
                    style={
                      this.state.chooseTutorEnabled
                        ? { display: "inline-block" }
                        : { display: "none" }
                    }
                  >
                    Choose Tutor
                  </button>

                  <button className="blue-button lesson-overview-button">
                    Lesson Overview
                  </button>

                  <p>Due Date: {moment(lesson.DueDate).format("llll")}</p>

                  <button
                    className="blue-button reschedule-button"
                    onClick={this.openScheduleModal}
                  >
                    Reschedule
                  </button>
                </div>
              ) : (
                <p>Preview</p>
              )}
            </div>
            <h2 className="lesson-title">
              <span>{`Lesson `}:</span> {`${this.state.lesson.Name}`}
            </h2>
            <div className="lesson-preview--content-container">
              {this.screendisplay2(this.state.currentscreen)}

              <div
                className="lesson-preview--content-sidebar"
                style={{
                  justifyContent: "flex-start",
                }}
              >
                <div className="lesson-preview--content-sidebar-nav">
                  <Scrollbars
                    className="school-res-disparea"
                    style={{
                      height: "60vh",
                      backgroundColor: "#1a1a1a",
                      padding: "0.5em",
                    }}
                  >
                    <Steps
                      direction="vertical"
                      current={this.state.currentscreenidx}
                      size="small"
                    >
                      {this.state.screens.map((screen) => {
                        const title = `${screen.Title[0].toUpperCase()}${screen.Title.toLowerCase().slice(
                          1
                        )}`;

                        return (
                          <Step
                            key={screen.id}
                            title={title}
                            disabled={
                              screen[keyscreentype] === 1 ? true : false
                            }
                          />
                        );
                      })}
                    </Steps>
                  </Scrollbars>
                </div>
                <div className="lesson-preview--content-sidebar-summary">
                  <h4>Summary</h4>
                  <p>{lesson.Description}</p>

                  <button
                    className="blue-button lesson-video"
                    onClick={this.toggleModal}
                  >
                    How do lessons work?
                  </button>
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default LessonPreviewPage;



// WEBPACK FOOTER //
// ./src/pages/SingleLesson/lessonPreviewPage.Component.tsx